import AuthorAndDateLabel from './AuthorAndDateLabel';

export default AuthorAndDateLabel;
